import { useContext, useMemo } from 'react';
import TagId from '~/constants/common/TagId';
import DiscountContext from '~/context/vdp/DiscountContext';
import {
  useGetVehicleDetails,
  useIsNewVehicle
} from '~/context/vdp/VehicleContext';

export default function usePriceDrop() {
  const { totalDiscount } = useContext(DiscountContext);
  const {
    previousPrice = 0,
    price = 0,
    priceUpdateDate,
    highlights
  } = useGetVehicleDetails();
  const isNewVehicle = useIsNewVehicle();
  const displayPrice = price - totalDiscount;
  const priceDrop = previousPrice && price && previousPrice - price;
  const hasPriceDropHighlight = useMemo(
    () =>
      highlights?.some(highlight => highlight.tagId === TagId.PriceDrop) ??
      false,
    [highlights]
  );

  const showPriceDrop = Boolean(
    previousPrice &&
      previousPrice - displayPrice > 0 &&
      hasPriceDropHighlight &&
      // Price drop on New cars are not supported until Search Pricing API returns incentivized previous price
      !isNewVehicle
  );

  return {
    previousPrice,
    price: displayPrice,
    priceDrop,
    priceUpdateDate,
    showPriceDrop,
    totalDiscount
  };
}
